var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.731 19a1 1 0 001 1h2.538a1 1 0 001-1v-6.731H19a1 1 0 001-1V8.73a1 1 0 00-1-1h-6.731V1a1 1 0 00-1-1H8.73a1 1 0 00-1 1v6.731H1a1 1 0 00-1 1v2.538a1 1 0 001 1h6.731V19z",
    fill: "#48B2B7"
  })));
}
export default SvgPlus;